import { switchMap } from 'rxjs/operators'
import { EMPTY } from 'rxjs'
import { Epic, ofType } from 'redux-observable'
import { NotificationRepository } from '../../../../repositories/notifications/NotificationRepository'
import AuthActionTypes from '../../actions/auth/AuthActionTypes'

const notificationRepository = new NotificationRepository()
/**
 * Subscribe notification listener on app init
 */
export const subscribeNotificationListenerOnInitEpic: Epic = (
  action$
) =>
  action$.pipe(
    ofType(
      AuthActionTypes.SET_IS_LOGGED,
      AuthActionTypes.REQUEST_LOGIN_SUCCESS
    ),
    switchMap(() => {
      notificationRepository.subscribeListener()
      return EMPTY
    })
  )

export const notificationsEpics = [
  subscribeNotificationListenerOnInitEpic,
]
